// Blocks imports
import initSearchBlocks from './blocks/typesense-search';
// Utils imports
import initAppearAnim from './utils/appear-anim';
import initDropdownGrid from './utils/dropdown-grid';
import initExpandableText from './utils/expandable-text';

// Partials imports
import initHeaderNavigation from './partials/header-navigation';

// Components imports
import initModals from './components/modal';
import initTabBars from './components/tabs';
import CollapsibleBox from './components/collapsible-box';
import ListingFilters from './components/listing-filters';
import ConventionCategory from './components/convention-category';
import ArticleSummary from './components/article-summary';
import HeaderSearch from './components/header-search';

// Fix de la valeur de '100vh' pour les appareils iOS + Fix de la valeur de '100vw'
function appHeight() {
  const vh = (window.innerHeight * 0.01) * 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const vw = document.body.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

function setHeaderHeight() {
  const header = document.querySelector('#main-header');
  document.documentElement.style.setProperty('--header-height', `${header?.getBoundingClientRect().height ?? 100}px`);
}

function onInit() {
  appHeight();
  setHeaderHeight();
}

window.addEventListener('load', onInit);
window.addEventListener('resize', onInit);


// Utils init
initAppearAnim();
initDropdownGrid();

// Partials init
initHeaderNavigation();

// Components init
initModals();
initTabBars();
customElements.define('collapsible-box', CollapsibleBox);
customElements.define('listing-filters', ListingFilters);
customElements.define('convention-category', ConventionCategory);
customElements.define('article-summary', ArticleSummary);
customElements.define('header-search', HeaderSearch);

// Init search blocks
initSearchBlocks();

// Init expandable text
initExpandableText();

